import { create } from 'axios';

// Environments
import { environment } from '../environments/environment';

// Constants
import { APP_CONFIG } from '../constants';

// Services
import { AuthService } from './../services';

// Helpers
import { errorHandler } from '../helpers';


export const VirtualCredentialApiInstance = create({

    baseURL: environment.apiVirtualCredential
});

VirtualCredentialApiInstance.interceptors.request.use(

  async config => {

    const accessToken = await AuthService.getAccessToken();
    
    config.headers = { 
      'Authorization': accessToken ? `${accessToken}` : '',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    return config;
  },
  error => {
    window?.DD_LOGS?.logger && window.DD_LOGS.logger.error(error);
    Promise.reject(error);
});

VirtualCredentialApiInstance.interceptors.response.use((response) => {
  
  if ( APP_CONFIG.API.VIRTUAL_CREDENTIAL.ERROR_CODE.includes(response.status) ) {

    return Promise.reject(errorHandler({response}, 'VIRTUAL_CREDENTIAL'));
  }  

  return response.data;

}, async function (error) {
  
  let exception = { statusCode: 500 };
  if ( error.response !== undefined ) {

    exception = { statusCode: error.response.status };
  }
  
  return Promise.reject(errorHandler(exception, 'VIRTUAL_CREDENTIAL'));
});